import {useSelector} from "react-redux";
import {
  selectTotalIncidentsCount,
  selectNewIncidentsCount,
  selectOpenIncidentsCount,
  selectUnassignedIncidentsCount
} from "../../../store/selectors";

export const useIncidentsCount = () => {
  const totalIncidentsCount = useSelector(selectTotalIncidentsCount);
  const totalNewIncidentsCount = useSelector(selectNewIncidentsCount);
  const totalOpenIncidentsCount = useSelector(selectOpenIncidentsCount);
  const totalUnassignedIncidentsCount = useSelector(
    selectUnassignedIncidentsCount
  );

  return {
    totalCount: totalIncidentsCount,
    newCount: totalNewIncidentsCount,
    openCount: totalOpenIncidentsCount,
    unassignedCount: totalUnassignedIncidentsCount
  };
};
